import { makeMain, makeUrlFilters } from './main';
import { Aside } from './components/Aside/Aside';
import { CatalogAppState } from './models';

(makeUrlFilters(window, document)());
(makeMain(window, document, Aside, CatalogAppState)());
